module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "author"
  }, [_c('div', {
    staticClass: "col-12 content no-gutters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "col-12 no-gutters",
    attrs: {
      "src": _vm.author.image,
      "alt": _vm.author.name + ' ' + _vm.author.surname
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row text"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.author.name) + " " + _vm._s(_vm.author.surname))]), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.translation.title))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7864214d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/AuthorCard.vue
// module id = 512
// module chunks = 1